import { render, staticRenderFns } from "./CompanyDefaultStats.vue?vue&type=template&id=75727a32"
import script from "./CompanyDefaultStats.vue?vue&type=script&lang=js"
export * from "./CompanyDefaultStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports